<template>
  <!-- 快捷生成完全可以由自己根据需求进行定义，因此这里仅开发了部分功能 -->
  <div class="cron-default-first">
    <Tabs @click="handleClick" size="small" type="card" v-model="activeName">
      <Tab-pane label="天" name="day">
        <RadioGroup @on-change="getValue" size="small" v-model="type">
          <div class="box-bottom">
            <Radio border label="1" size="small">每天0点整执行</Radio>
          </div>
          <div class="box-bottom cycle">
            <Radio border label="2" size="small">自定义时分</Radio>
            <div style v-if="type == '2'">
              <span style="margin-right:0.5rem;">每天</span>
              <InputNumber
                :max="23"
                :min="0"
                @on-change="getChangeDayHourTime"
                size="small"
                style="width: 4rem;"
                v-model="day.hour"
              ></InputNumber>
              <span style="margin:0 0.5rem;">点</span>
              <InputNumber
                :max="59"
                :min="0"
                @on-change="getChangeDayHourTime"
                size="small"
                style="width: 4rem;"
                v-model="day.minute"
              ></InputNumber>
              <span style="margin-left:8px;">分执行</span>
            </div>
          </div>
        </RadioGroup>
      </Tab-pane>
      <Tab-pane label="周" name="week">
        <RadioGroup @on-change="getValue" size="small" v-model="type">
          <div class="box-bottom">
            <Radio border label="11" size="small">每周一0点整执行</Radio>
          </div>
          <div class="box-bottom">
            <Radio border label="12" size="small">每工作日0点整执行</Radio>
          </div>
          <div class="box-bottom">
            <Radio border label="13" size="small">每周末0点整执行</Radio>
          </div>
          <div class="box-bottom cycle">
            <Radio border label="14" size="small">自定义执行星期和时分</Radio>
            <div v-if="type == '14'">
              <span style="margin-right:0.5rem;">每周</span>
              <Select
                @on-change="getChangeWeekTime"
                multiple
                placeholder="请选择"
                size="small"
                style="width:6rem;"
                transfer
                v-model="weekDay.week"
              >
                <Option :value="'1'" label="日"></Option>
                <Option :value="'2'" label="一"></Option>
                <Option :value="'3'" label="二"></Option>
                <Option :value="'4'" label="三"></Option>
                <Option :value="'5'" label="四"></Option>
                <Option :value="'6'" label="五"></Option>
                <Option :value="'7'" label="六"></Option>
              </Select>
              <InputNumber
                :max="23"
                :min="0"
                @on-change="getChangeWeekTime"
                size="small"
                style="width: 4rem;"
                v-model="weekDay.hour"
              ></InputNumber>
              <span style="margin:0 0.5rem;">点</span>
              <InputNumber
                :max="59"
                :min="0"
                @on-change="getChangeWeekTime"
                size="small"
                style="width: 4rem;"
                v-model="weekDay.minute"
              ></InputNumber>
              <span style="margin-left:0.5rem;">分执行</span>
            </div>
          </div>
        </RadioGroup>
      </Tab-pane>
      <Tab-pane label="月" name="month">
        <RadioGroup @on-change="getValue" size="small" v-model="type">
          <div class="box-bottom">
            <Radio border label="21" size="small">每月1号0点执行</Radio>
          </div>
          <div class="box-bottom">
            <Radio border label="22" size="small">每月15号0点执行</Radio>
          </div>
          <div class="box-bottom cycle">
            <Radio border label="23" size="small">自定义执行日和时分</Radio>
            <div v-if="type=='23'">
              <span style="margin-right:0.5rem;">每月</span>
              <InputNumber
                :max="31"
                :min="1"
                @on-change="getChangeMonthTime"
                size="small"
                style="width: 4rem;"
                v-model="month.day"
              ></InputNumber>
              <span style="margin:0 0.5rem;">(号)</span>
              <InputNumber
                :max="23"
                :min="0"
                @on-change="getChangeMonthTime"
                size="small"
                style="width: 4rem;"
                v-model="month.hour"
              ></InputNumber>
              <span style="margin:0 0.5rem;">点</span>
              <InputNumber
                :max="59"
                :min="0"
                @change="getChangeMonthTime"
                size="small"
                style="width: 4rem;"
                v-model="month.minute"
              ></InputNumber>
              <span style="margin-left:0.5rem;">分执行</span>
            </div>
          </div>
        </RadioGroup>
      </Tab-pane>
    </Tabs>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeName: "day",
      // 当前选择
      type: "1",
      // 每天几点执行
      day: {
        hour: 0,
        minute: 0
      },
      // 每周几 几点执行
      weekDay: {
        week: 2,
        hour: 0,
        minute: 0
      },
      // 月
      month: {
        day: 1,
        hour: 0,
        minute: 0
      },
      // 最终表达式
      cronExpression: "0 0 0 * * ?"
    }
  },
  methods: {
    resetValue () {
      this.day = {
        hour: 0,
        minute: 0
      }
      this.weekDay = {
        week: 2,
        hour: 0,
        minute: 0
      }
      this.month = {
        day: 1,
        hour: 0,
        minute: 0
      }
    },
    // 获取当前值
    getValue () {
      this.resetValue()
      if (this.type == "1") {
        // 每天0点整执行
        this.cronExpression = "0 0 0 * * ?"
      } else if (this.type == "2") {
        // 每天*点*分执行
        this.cronExpression =
          "0 " + this.day.minute + " " + this.day.hour + " * * ?"
      } else if (this.type == "11") {
        // 每周一0点整执行
        this.cronExpression = "0 0 0 ? * 2"
      } else if (this.type == "12") {
        // 每周一至周五0点整执行
        this.cronExpression = "0 0 0 ? * 2-6"
      } else if (this.type == "13") {
        // 每周末0点整执行
        this.cronExpression = "0 0 0 ? * 1,7"
      } else if (this.type == "14") {
        // 每周几 几点几分执行
        this.cronExpression =
          "0 " +
          this.weekDay.minute +
          " " +
          this.weekDay.hour +
          " ? * " +
          this.weekDay.week
      } else if (this.type == "21") {
        // 每月1号0点
        this.cronExpression = "0 0 0 1 * ?"
      } else if (this.type == "22") {
        // 每月15号0点
        this.cronExpression = "0 0 0 15 * ?"
      } else if (this.type == "23") {
        // 每月几号几点几分执行
        this.cronExpression =
          "0 " +
          this.month.minute +
          " " +
          this.month.hour +
          " " +
          this.month.day +
          " * ?"
      }
      this.$emit("change", this.cronExpression)
    },
    // 每天几点开始执行
    getChangeDayHourTime () {

      this.type = "2"
      this.cronExpression =
        "0 " + this.day.minute + " " + this.day.hour + " * * ?"
      console.log('getChangeDayHourTime', this.cronExpression)
      this.$emit("change", this.cronExpression)
    },
    // 每周几 几点几分执行
    getChangeWeekTime () {
      this.type = "14"
      this.cronExpression =
        "0 " +
        this.weekDay.minute +
        " " +
        this.weekDay.hour +
        " ? * " +
        this.weekDay.week.join(",")
      this.$emit("change", this.cronExpression)
    },
    // 每月几号几点几分执行
    getChangeMonthTime () {
      this.type = "23"
      this.cronExpression =
        "0 " +
        this.month.minute +
        " " +
        this.month.hour +
        " " +
        this.month.day +
        " * ?"
      this.$emit("change", this.cronExpression)
    },
    // tab选择重置内容
    handleClick () {
      if (this.activeName == "day") {
        this.type = "1"
        this.getValue()
      } else if (this.activeName == "week") {
        this.type = "11"
        this.getValue()
      } else {
        this.type = "21"
        this.getValue()
      }
    }
  }
};
</script>
<style lang="css">
.cron-default-first .box-bottom {
  margin-bottom: 8px;
}
.cron-default-first .cycle {
  font-size: 12px;
}
.cron-default-first .Tabs .Tabs__content {
  overflow-x: hidden;
  overflow-y: auto;
  height: 220px;
}
.cron-default-first .table-box {
  border-top: 1px solid #ebebeb;
  margin-top: 10px;
  padding-top: 10px;
  min-width: 400px;
}
</style>